import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { BatchHttpLink } from 'apollo-link-batch-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { chimeraBasicURL } from '@/dex-shared/settings/endpoints';
import gql from 'graphql-tag';
import fetch from 'unfetch';

var chimeraHttpLink = new BatchHttpLink({
  uri: chimeraBasicURL,
  fetchOptions: fetch,
});

var chimeraAuthLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      authorization:
        'ServiceProvider ZGV4LWFkbWluOktLNVRkeEo2LWdFTUctSWlEWi1zUWxBLWdJbVpnVWI5ZlNHaw==',
    },
  };
});

const chimeraLink = ApolloLink.from([chimeraAuthLink, chimeraHttpLink]);

export const chimeraClient = new ApolloClient({
  link: chimeraLink,
  cache: new InMemoryCache(),
  connectToDevTools: true,
  defaultOptions: {
    query: {
      fetchPolicy: 'no-cache',
    },
  },
});

export async function chimeraQuery(
  query: string,
  variables?: { [key: string]: any },
): Promise<any> {
  return await chimeraClient.query<any>({
    query: gql(query),
    variables: variables,
  });
}
